import Breadcrumb from "../components/BreadCurmb";
import HeaderOne from "../header/HeaderOne";
import FooterOne from "../footer/FooterOne"
import ModalVideo from 'react-modal-video';
import React, { useState } from 'react';
import {BrowserRouter as  Routes, Link, Route} from 'react-router-dom'
export default function Team(){
	const [isOpen, setIsOpen] = useState(false);
    const openModal = () => setIsOpen(!isOpen);
	return(
	
		 <>
		<HeaderOne/>
		<Breadcrumb title="Our Team" subtitle="Responsive Team Details Page" pagetitle="Team Page"/>
		<ModalVideo channel='youtube' isOpen={isOpen} videoId='S05bHj0LBE4' onClose={() => { openModal(); }} />
		<section className="team-area2 pt-120 pb-70 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30">
			<div className="container">
				<div className="row">
					<div className="col-lg-3 col-md-6">
						<div className="team-wrapper text-center mb-45">
							<div className="team-thumb">
								<img src="assets/img/team/team-1.jpg"  alt="image" />
								<div className="team-icon-wrapper">
									<div className="inner-team-icon pos-rel">
										<div className="team-icon">
											<Link className="twitter" to="#"><i className="fab fa-twitter"></i></Link>
											<Link className="google" to="#"><i className="fab fa-youtube"></i></Link>
											<Link className="behance" to="#"><i className="fab fa-instagram"></i></Link>
											<Link className="fb" to="#"><i className="fab fa-facebook-f"></i></Link>
											<Link className="plus" to="#"><i className="fal fa-plus"></i></Link>
										</div>
									</div>
								</div>
							</div>
							<div className="team-content">
								<h6 className="theme-col">Founder</h6>
								<h4 className="sub-title text-heding2">Rosalia D. William</h4>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="team-wrapper text-center mb-45">
							<div className="team-thumb">
								<img src="assets/img/team/team-2.jpg"  alt="image" />
								<div className="team-icon-wrapper">
									<div className="inner-team-icon pos-rel">
										<div className="team-icon">
											<Link className="twitter" to="#"><i className="fab fa-twitter"></i></Link>
											<Link className="google" to="#"><i className="fab fa-youtube"></i></Link>
											<Link className="behance" to="#"><i className="fab fa-instagram"></i></Link>
											<Link className="fb" to="#"><i className="fab fa-facebook-f"></i></Link>
											<Link className="plus" to="#"><i className="fal fa-plus"></i></Link>
										</div>
									</div>
								</div>
							</div>
							<div className="team-content">
								<h6 className="theme-col">CEO</h6>
								<h4 className="sub-title text-heding2">Miranda H. Halim</h4>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="team-wrapper text-center mb-45">
							<div className="team-thumb">
								<img src="assets/img/team/team-3.jpg"  alt="image" />
								<div className="team-icon-wrapper">
									<div className="inner-team-icon pos-rel">
										<div className="team-icon">
											<Link className="twitter" to="#"><i className="fab fa-twitter"></i></Link>
											<Link className="google" to="#"><i className="fab fa-youtube"></i></Link>
											<Link className="behance" to="#"><i className="fab fa-instagram"></i></Link>
											<Link className="fb" to="#"><i className="fab fa-facebook-f"></i></Link>
											<Link className="plus" to="#"><i className="fal fa-plus"></i></Link>
										</div>
									</div>
								</div>
							</div>
							<div className="team-content">
								<h6 className="theme-col">Designer</h6>
								<h4 className="sub-title text-heding2">Alexis J. Jhalmuri</h4>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="team-wrapper text-center mb-45">
							<div className="team-thumb">
								<img src="assets/img/team/team-4.jpg"  alt="image" />
								<div className="team-icon-wrapper">
									<div className="inner-team-icon pos-rel">
										<div className="team-icon">
											<Link className="twitter" to="#"><i className="fab fa-twitter"></i></Link>
											<Link className="google" to="#"><i className="fab fa-youtube"></i></Link>
											<Link className="behance" to="#"><i className="fab fa-instagram"></i></Link>
											<Link className="fb" to="#"><i className="fab fa-facebook-f"></i></Link>
											<Link className="plus" to="#"><i className="fal fa-plus"></i></Link>
										</div>
									</div>
								</div>
							</div>
							<div className="team-content">
								<h6 className="theme-col">Marketer</h6>
								<h4 className="sub-title text-heding2">Piona L. Limonda</h4>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="team-wrapper text-center mb-45">
							<div className="team-thumb">
								<img src="assets/img/team/team-5.jpg"  alt="image" />
								<div className="team-icon-wrapper">
									<div className="inner-team-icon pos-rel">
										<div className="team-icon">
											<Link className="twitter" to="#"><i className="fab fa-twitter"></i></Link>
											<Link className="google" to="#"><i className="fab fa-youtube"></i></Link>
											<Link className="behance" to="#"><i className="fab fa-instagram"></i></Link>
											<Link className="fb" to="#"><i className="fab fa-facebook-f"></i></Link>
											<Link className="plus" to="#"><i className="fal fa-plus"></i></Link>
										</div>
									</div>
								</div>
							</div>
							<div className="team-content">
								<h6 className="theme-col">Marketer</h6>
								<h4 className="sub-title text-heding2">Rosalina L. Monta</h4>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="team-wrapper text-center mb-45">
							<div className="team-thumb">
								<img src="assets/img/team/team-6.jpg"  alt="image" />
								<div className="team-icon-wrapper">
									<div className="inner-team-icon pos-rel">
										<div className="team-icon">
											<Link className="twitter" to="#"><i className="fab fa-twitter"></i></Link>
											<Link className="google" to="#"><i className="fab fa-youtube"></i></Link>
											<Link className="behance" to="#"><i className="fab fa-instagram"></i></Link>
											<Link className="fb" to="#"><i className="fab fa-facebook-f"></i></Link>
											<Link className="plus" to="#"><i className="fal fa-plus"></i></Link>
										</div>
									</div>
								</div>
							</div>
							<div className="team-content">
								<h6 className="theme-col">Marketer</h6>
								<h4 className="sub-title text-heding2">Piona L. Limonda</h4>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="team-wrapper text-center mb-45">
							<div className="team-thumb">
								<img src="assets/img/team/team-7.jpg"  alt="image" />
								<div className="team-icon-wrapper">
									<div className="inner-team-icon pos-rel">
										<div className="team-icon">
											<Link className="twitter" to="#"><i className="fab fa-twitter"></i></Link>
											<Link className="google" to="#"><i className="fab fa-youtube"></i></Link>
											<Link className="behance" to="#"><i className="fab fa-instagram"></i></Link>
											<Link className="fb" to="#"><i className="fab fa-facebook-f"></i></Link>
											<Link className="plus" to="#"><i className="fal fa-plus"></i></Link>
										</div>
									</div>
								</div>
							</div>
							<div className="team-content">
								<h6 className="theme-col">Marketer</h6>
								<h4 className="sub-title text-heding2">Piona L. Mironda</h4>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="team-wrapper text-center mb-45">
							<div className="team-thumb">
								<img src="assets/img/team/team-8.jpg"  alt="image" />
								<div className="team-icon-wrapper">
									<div className="inner-team-icon pos-rel">
										<div className="team-icon">
											<Link className="twitter" to="#"><i className="fab fa-twitter"></i></Link>
											<Link className="google" to="#"><i className="fab fa-youtube"></i></Link>
											<Link className="behance" to="#"><i className="fab fa-instagram"></i></Link>
											<Link className="fb" to="#"><i className="fab fa-facebook-f"></i></Link>
											<Link className="plus" to="#"><i className="fal fa-plus"></i></Link>
										</div>
									</div>
								</div>
							</div>
							<div className="team-content">
								<h6 className="theme-col">Marketer</h6>
								<h4 className="sub-title text-heding2">Hiron L. Limonda</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		
		<section className="video-area">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-lg-9">
						<div className="video-wrapper" style={{backgroundImage: `url(assets/img/video/video-bg1.jpg)`}}>
						<Link onClick={() => { openModal(); }} className="popup-video">
												<i className="far fa-play"></i>
											</Link>
							
						</div>
					</div>
				</div>
			</div>
		</section>
		
		<section className="grey-bg counter-area pt-300 pb-90 pt-md-50 pb-md-30 pt-xs-50 pb-xs-30">
			<div className="container">
				<div className="row pt-100 pt-md-10 pt-xs-10">
					<div className="col-lg-12">
						<div className="section-title text-center mb-60">
							<p className="lh-1 mb-10">Fun Fact</p>
							<h2 className="sect-title">Company’s fun fact</h2>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-lg-3 col-md-6">
						<div className="white-bg count-bar text-center mb-30">
							<div className="chart" data-percent="73">
								<img src="assets/img/icon/c-1d.png" alt="Icon" />
							</div>
							<h5 className="fs-20">1000 Happy Clients</h5>
							<p>Voice and Data Systems are
								crucial to the success</p>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="white-bg count-bar text-center mb-30">
							<div className="chart" data-percent="73">
								<img src="assets/img/icon/c-2d.png" alt="Icon" />
							</div>
							<h5 className="fs-20">1000 Happy Clients</h5>
							<p>Voice and Data Systems are
								crucial to the success</p>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="white-bg count-bar text-center mb-30">
							<div className="chart" data-percent="73">
								<img src="assets/img/icon/c-3d.png" alt="Icon" />
							</div>
							<h5 className="fs-20">1000 Happy Clients</h5>
							<p>Voice and Data Systems are
								crucial to the success</p>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="white-bg count-bar text-center mb-30">
							<div className="chart" data-percent="73">
								<img src="assets/img/icon/c-4d.png" alt="Icon" />
							</div>
							<h5 className="fs-20">1000 Happy Clients</h5>
							<p>Voice and Data Systems are
								crucial to the success</p>
						</div>
					</div>
				</div>
			</div>
		</section>
		<FooterOne/>

		</>
	)
	
}